<template>
  <div class="container">
    <div class="top-box">
      <div class="flexrbc">
        <div class="flexr0c">
          <div class="title-label"></div>
          <div class="title">交收单过站查询</div>
        </div>
        <div class="addOrg flexrcc" @click="exportTable">
          <div class="btn">导出</div>
        </div>
      </div>
    </div>
    <div class="search-box flexr0c">
      <div class="flexr0c dispatch-time">
        <div class="label">时间范围</div>
        <Row>
          <Col span="12">
            <DatePicker format="yyyy/MM/dd HH:mm:ss" :editable="false" :value="dateRange" type="datetimerange" placement="bottom-end" placeholder="选择日期" style="width: 350px" @on-change="handleChange" @on-ok="handleConfirm" :clearable="false"></DatePicker>
          </Col>
        </Row>
      </div>
      <div class="flexr0c select-box">
        <div class="label">交易矿种</div>
        <Select v-model="select1" style="width: 110px" @on-change="changeStatus">
          <Option v-for="item in oreList" :value="item.value" :key="item.index">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="flexr0c search-item">
        <div class="label">需方企业</div>
        <Input v-model="needCom" placeholder="" style="width: 220px" @on-blur="getPage(1)" @on-enter="getPage(1)">
          <Icon type="ios-search" slot="suffix" />
        </Input>
      </div>
    </div>
    <div class="content-box">
      <div class="content">
        <div class="flexr0c" style="margin-bottom: 20px">
          <div class="big-title">
            <div class="title-box flexr0c">
              <div class="title">过站/调运车次</div>
              <div class="title">累计重量(吨)</div>
              <div class="title">累计税费(元)</div>
            </div>
            <div class="item-box flexr0c">
              <div class="num num1">{{ moneyObj.totalCount }}</div>
              <div class="num num2">{{ moneyObj.realNetweight }}</div>
              <div class="num num4">{{ moneyObj.payMoney }}</div>
            </div>
          </div>
          <div class="number-card flexr0c">
            <div class="left">
              <div class="label">
                领用票据 <span>{{ billObj.totalCount }}</span>
              </div>
              <div class="label">
                已用票据 <span>{{ billObj.used }}</span>
              </div>
            </div>
            <div class="split-line"></div>
            <div class="right">
              <div class="label">
                未用票据 <span>{{ billObj.unused }}</span>
              </div>
              <div class="label">
                作废票据 <span>{{ billObj.cancelCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table">
          <Table max-height="" :loading="loading" border stripe :columns="tableHead" :data="tableData">
            <template slot-scope="{ row }" slot="buyerName">
              <div>{{ row.buyerName }}</div>
            </template>
          </Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'settlement',
  data() {
    return {
      msg: '',
      dateRange: [],
      carId: '',
      userName: '',
      select1: '',
      select3: '',
      needCom: '',
      oreList: [
        {
          value: '全部',
          label: '全部'
        }
      ],
      moneyObj: {},
      billObj: {},
      total: 0,
      pageSize: 12,
      loading: true,
      tableHead: [
        {
          title: '矿种',
          key: 'oreName',
          width: 150,
          resizable: true
        },
        {
          title: '过站时间',
          key: 'addTime',
          width: 190,
          resizable: true
        },
        {
          title: '车牌号码',
          key: 'plateNum',
          width: 110,
          resizable: true
        },
        {
          title: '过站重量(吨)',
          key: 'realNetweight',
          width: 130,
          resizable: true
        },
        {
          title: '过站税费(元)',
          key: 'payMoney',
          width: 130,
          align: 'left',
          resizable: true
        },
        {
          title: '计量站',
          key: 'stationName',
          width: 180,
          align: 'left',
          resizable: true
        },
        {
          title: '调运企业',
          key: 'enterpriseName',
          width: 240,
          align: 'left',
          resizable: true
        },
        {
          title: '需方企业',
          slot: 'buyerName',
          width: 240,
          align: 'left',
          resizable: true
        },
        {
          title: '起运地',
          key: 'sourceArea',
          width: 220,
          align: 'left',
          resizable: true
        },
        {
          title: '目的地',
          key: 'destArea',
          width: 80,
          align: 'left',
          resizable: true
        }
      ],
      tableData: []
    };
  },
  created() {
    let date2 = this.dateFormat('YYYY-mm-dd', new Date());
    this.dateRange.push(date2 + ' 00:00:00');
    this.dateRange.push(date2 + ' 23:59:59');
    this.getPage(1);
    this.getSelect();
  },
  methods: {
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    changePage(page) {
      this.getPage(page);
    },
    changeStatus() {
      this.getPage(1);
    },
    handleChange(dateRange) {
      const arr = [];
      arr[0] = dateRange[0].replace(/\//g, '-');
      arr[1] = dateRange[1].replace(/\//g, '-');
      this.dateRange = arr;
    },
    handleConfirm() {
      this.getPage(1);
    },
    getSelect() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        modeCode: '8Nj3MDYFYm6AMtHz8dYeDsMk7bEAC8Cg'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            let obj = {};
            obj.value = item.oreId;
            obj.label = item.oreName;
            this.oreList.push(obj);
          });
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getPage(index) {
      this.loading = true;
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        modeCode: 'jZJh7GeDIS8ahcFHzuWXUeBQ88loqmiU',
        enterpriseId: session.enterpriseId,
        userId: session.userId,
        pageIndex: index,
        pageSize: this.pageSize
      };
      if (this.dateRange.length != 0) {
        data.startTime = this.dateRange[0].replace(/\//g, '-');
        data.endTime = this.dateRange[1].replace(/\//g, '-');
      }
      this.select1 && this.select1 != '全部' ? (data.oreId = this.select1) : data;
      this.needCom ? (data.buyerNameKw = this.needCom) : data;
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.data.count;
          this.tableData = res.data.result_ctn;
          this.moneyObj = res.data.total;
          this.billObj = res.data.usageOfBills;
          this.billObj.used = this.billObj.notransCount + this.billObj.dtlCount;
          this.billObj.unused = this.billObj.totalCount - this.billObj.notransCount - this.billObj.dtlCount - this.billObj.cancelCount;
          this.loading = false;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
          this.loading = false;
        }
      });
    },
    // 导出接口
    exportTable() {
      const session = JSON.parse(localStorage['session']);
      let data = {
        modeCode: 'Dv5gOBxrjwucvGh5EsJzmrHIAD0Zq4ba',
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        fileName: '交收单过站查询', // 导出文件名称
        suffix: 'xlsx' // 导出文件类型
      };
      if (this.dateRange.length != 0) {
        data.startTime = this.dateRange[0].replace(/\//g, '-');
        data.endTime = this.dateRange[1].replace(/\//g, '-');
      }
      this.select1 && this.select1 != '全部' ? (data.oreId = this.select1) : data;
      this.needCom ? (data.buyerNameKw = this.needCom) : data;
      this.$http.exportMethod(data).then((res) => {});
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  // height: 780px;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f2f3f5;
  position: relative;

  .top-box {
    background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 40px;

    & > div {
      height: 100%;
      width: 928px;
      margin: 0 auto;
    }

    .title-label {
      width: 4px;
      height: 14px;
      background: #2c59c3;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #2c59c3;
      letter-spacing: 0.4px;
      margin-left: 6px;
    }

    .addOrg {
      background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
      border: 1px solid #4c9b25;
      border-radius: 6px;
      width: 110px;
      height: 30px;
      cursor: pointer;

      &:hover {
        background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
      }

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      .btn {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
      }
    }
  }

  .search-box {
    height: 74px;

    .label {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #616c84;
      letter-spacing: 0;
      margin-right: 10px;
    }

    .select-box,
    .search-item,
    .dispatch-time {
      margin-left: 25px;
    }

    /deep/.ivu-select-selected-value {
      height: 38px;
      line-height: 38px;
      text-align: left;
    }

    /deep/.ivu-select-selection,
    /deep/.ivu-input {
      height: 38px;
      // border: 1px solid #CCD1DD;
      box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
      border-radius: 4px;
    }

    /deep/ .ivu-input-suffix i {
      line-height: 38px;
    }

    /deep/.ivu-date-picker-focused input,
    /deep/.ivu-date-picker-focused input {
      font-size: 14px;
    }

    /deep/.ivu-select-selected-value,
    /deep/.ivu-select-item {
      text-align: start;
    }

    /deep/.ivu-input-with-suffix {
      cursor: pointer;
    }

    /deep/.ivu-select-selection {
      height: 38px;
      background: #ffffff;
      // border: 1px solid #DFDFDF;
      box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      border-radius: 8px;
    }

    /deep/.ivu-select-placeholder,
    /deep/.ivu-select-selected-value {
      height: 38px;
      line-height: 38px;
      padding-left: 24px;
      text-align: start;
    }

    /deep/.ivu-input-suffix {
      line-height: 38px;
    }

    /deep/.ivu-input-with-suffix {
      height: 38px;
      line-height: 38px;
      padding-left: 24px;
      background: #ffffff;
      // border: 1px solid #DFDFDF;
      box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      border-radius: 8px;
    }
  }

  .content-box {
    width: 980px;
    // height: 636px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;

    .content {
      width: 980px;
      margin-top: 15px;

      .big-title {
        width: 578px;
        height: 102px;
        margin-left: 26px;

        .title-box {
          width: 578px;
          height: 40px;
          background-color: rgba(224, 229, 240, 0.3);

          .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #8b93a7;
            flex: 1;
          }
        }

        .item-box {
          width: 578px;
          height: 50px;

          .num {
            font-family: Impact;
            font-size: 24px;
            flex: 1;
            margin: 10px 0;
          }

          .num1 {
            color: #7ed321;
          }

          .num2 {
            color: #4a90e2;
          }

          .num3 {
            color: #2c59c3;
          }

          .num4 {
            color: #f5a623;
          }
        }
      }

      .number-card {
        width: 334px;
        height: 102px;
        border: 1px solid #dce0e7;
        border-radius: 4px;
        margin-left: 16px;
        padding: 8px;
        box-sizing: border-box;

        .left,
        .right {
          //   padding-left: 20px;
          //   padding-right: 36px;
          padding: auto;
          box-sizing: border-box;
          width: 190px;
          text-align: justify;

          .label {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #8b93a7;
            letter-spacing: 0;
            line-height: 30px;

            span {
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #2c59c3;
              letter-spacing: 0;
              margin-left: 6px;
            }
          }
        }

        .right {
          padding-left: 15px;
          padding-right: 20px;
          box-sizing: border-box;
        }

        .split-line {
          width: 1px;
          height: 50px;
          background-color: #dce0e7;
        }
      }

      .table {
        width: 928px;
        margin-left: 26px;
      }

      /deep/ .ivu-table th {
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:last-child {
        border-top-right-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:first-child {
        // border-top-left-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }
    }
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #f3f3f3;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }
}
</style>
